<!--
  pwa-instructions-modal.component.html
  Modal shell (toolbar + close) around the shared instructions content. The steps
  themselves are app-pwa-instructions — this file must never restate them.
  heading="" suppresses the content's own H1, since the toolbar title says it.
-->

<ion-modal [isOpen]="isOpen" (didDismiss)="onClose()" class="card-popup">
  <ng-template>

    <ion-header>
      <ion-toolbar>
        <ion-title>{{ title }}</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="onClose()">
            <ion-icon name="close" slot="start"></ion-icon>
            Close
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <div class="install-modal-body">
        <app-pwa-instructions heading=""></app-pwa-instructions>
      </div>
    </ion-content>

  </ng-template>
</ion-modal>
